import React, {useEffect} from 'react'
import './home.css';
import { Link } from 'react-router-dom'
import Photo from './../assets/Photo.png'
import Gems from './../assets/Gems.png'

function Home() {
	useEffect(() => {
		document.getElementById('photoLogo').classList.remove('animate');
		document.getElementById('gemsLogo').classList.remove('animate');
		document.getElementById('homeContent').classList.remove('animate');
		
		setTimeout(() => {
			document.getElementById('photoLogo').classList.add('animate');
			document.getElementById('gemsLogo').classList.add('animate');
			document.getElementById('homeContent').classList.add('animate');
		}, 10);
	}, [])

	return (
		<div id="home">
			<div id="wrapperLeft">
				<img id="photoLogo" src={Photo}/>
			</div>
			<div id="wrapperRight">
				<img id="gemsLogo" src={Gems}/>
			</div>
			<div id="homeContent">
				Welcome to PhotoGems!<br/>
				PhotoGems is a social media network that allows you to share pictures with your friends and associates.
			</div>
			<div id="footer">
			<div id="emailFooter">Contact email address: &nbsp; <a href="mailto:etay2468@gmail.com"><u>etay2468@gmail.com</u></a></div>
			<Link to={'/profile/eZds0J2Z5YVqDkTHbSsqpHDLL4l2'}>Ⓒ All rights reserved. Made with love by <strong>Itay Shiff  😊</strong></Link>
			</div>
		</div>
	)
}

export default Home